import type { IconData } from '@stacksjs/iconify-core'

export const cm1x1: IconData = {
  "body": "<path fill=\"#007a5e\" d=\"M0 0h170.7v512H0z\"/><path fill=\"#ce1126\" d=\"M170.7 0h170.6v512H170.7z\"/><path fill=\"#fcd116\" d=\"M341.3 0H512v512H341.3z\"/><g fill=\"#fcd116\" transform=\"translate(256 256)scale(5.6889)\"><g id=\"SVG7njaB7bZ\"><path id=\"SVG3NvIFRSJ\" d=\"M0-8L-2.5-.4L1.3.9z\"/><use width=\"100%\" height=\"100%\" href=\"#SVG3NvIFRSJ\" transform=\"scale(-1 1)\"/></g><use width=\"100%\" height=\"100%\" href=\"#SVG7njaB7bZ\" transform=\"rotate(72)\"/><use width=\"100%\" height=\"100%\" href=\"#SVG7njaB7bZ\" transform=\"rotate(144)\"/><use width=\"100%\" height=\"100%\" href=\"#SVG7njaB7bZ\" transform=\"rotate(-144)\"/><use width=\"100%\" height=\"100%\" href=\"#SVG7njaB7bZ\" transform=\"rotate(-72)\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cm1x1
